export const env = {
	apiUrl: process.env.REACT_APP_API_URL
}
